import axiosService from '../utils/axios';

async function getSignedInUser() {
    const { data } = await axiosService.get('/user/');
    return data;
}

async function getUser(userId: string) {
    const { data } = await axiosService.get(`/user/${userId}/`);
    return data;
}

async function getReferralLink() {
    const { data } = await axiosService.post('/user/referralCode/');
    return data?.link;
}

async function getLikedUsers() {
    const { data } = await axiosService.get('/user/like');
    return data;
}

async function getLikeStatus(likedUserId: string) {
    const { data } = await axiosService.get(`/user/like/${likedUserId}`);
    return data;
}

async function likeUser(likedUserId: string) {
    const { data } = await axiosService.post(`/user/like/${likedUserId}`);
    return data;
}

async function unlikeUser(likedUserId: string) {
    const { data } = await axiosService.delete(`/user/like/${likedUserId}`);
    return data;
}

export const getUserBoostStatus = async () => {
    const { data } = await axiosService.get('/user/boost-status');
    return data;
};

export {
    getSignedInUser,
    getUser,
    getReferralLink,
    getLikedUsers,
    getLikeStatus,
    likeUser,
    unlikeUser
};
